<template>
	<el-dialog :title="title" :visible.sync="visible" width="450px" class="confirmProp" :close-on-click-modal="false">
		<div>
			<div class="textC">
				<!-- 问号 question-->
				<!-- <img src="../../assets/img/tanchuang/icon-5.png" alt="" class="imgsize1" v-if="type === 'question'"/> -->
				
				<i class="iconfont icontishichuang1 tanchuang-icon" v-if="type === 'question'" style="color:#72c7ff"></i>
				<!-- 警告 warning -->
				<!-- <img src="../../assets/img/tanchuang/icon-3.png" alt="" class="imgsize2" v-if="type === 'warning'"/> -->
				<i class="iconfont icontishichuang3 tanchuang-icon" v-if="type === 'warning'" style="color:#ff9595"></i>
				<!-- 操作成功 success-->
				<!-- <img src="../../assets/img/tanchuang/icon-2.png" alt="" class="imgsize1" v-if="type === 'success'"/> -->
				<i class="iconfont icontishichuang2 tanchuang-icon" v-if="type === 'success'" style="color:#6cc288"></i>
			    <!-- 提示 tips-->
				<!-- <img src="../../assets/img/tanchuang/icon-4.png" alt="" class="imgsize3" v-if="type === 'tips'" /> -->
				<i class="iconfont icontishichuang3 tanchuang-icon"  v-if="type === 'tips'" style="color:#72c7ff"></i>
				</div>
			<div class="texts textC">{{ content }}</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleAction('yes')" class="addbtn btn-icon-flex">
				<!-- <img src="../../assets/img/tanchuang/queding.png" alt="" /> -->
				<i class="iconfont iconqueding btn-icon"></i>
				<span>{{ yesBtnText }}</span>
			</el-button>
			<el-button type="primary" @click="handleAction('cancel')" class="deletbtn btn-icon-flex" v-if="isShowCancelBtn">
				<!-- <img src="../../assets/img/tanchuang/quxiao.png" alt="" /> -->
				<i class="iconfont iconguanbi btn-icon textColor btn-quxiao" ></i>
				<span>{{ cancelBtnText }}</span>
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'MyConfirm',
	data() {
		return {
			visible: false,
			title: '系统提示',
			content: '请选择要编辑的数据',
			yesBtnText: '确 定',//确定按钮的文字
			cancelBtnText: '取 消',//取消按钮的文字
			type: 'tips', //
			promiseStatus: null,
			isShowCancelBtn: false,//是否显示取消按钮
		};
	},
	watch: {
		visible: function(curVal) {
			// if (curVal && document.body.scrollHeight > window.innerHeight) {
			// 	$('body').addClass('backdrop-open');
			// } else {
			// 	$('body').removeClass('backdrop-open');
			// }
		}
	},
	methods: {
		confirm() {
			let _this = this;
			this.visible = true;
			return new Promise(function(resolve, reject) {
				_this.promiseStatus = { resolve, reject };
			});
		},
		handleAction(action) {
			this.visible = false;
			if (action == 'yes') {
				this.promiseStatus && this.promiseStatus.resolve();
			} else {
				this.promiseStatus && this.promiseStatus.reject();
			}
		}
	}
};
</script>

<style lang="less">
.confirmProp {
	.el-dialog .el-dialog__body {
		padding-top: 33px;
		padding-bottom: 44px;
	}
	.el-dialog .el-dialog__footer {
		padding-top: 0px;
		padding-bottom: 39px;
	}
	.texts {
		font-family: MicrosoftYaHei;
		// font-size: 18px;
		// font-weight: normal;
		// font-stretch: normal;
		// letter-spacing: 1px;
		// color: #47ba6d;
		margin-top: 12px;

		font-family: MicrosoftYaHei;
		font-size: 16px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #666666;
	}
	.addbtn {
		width: 140px;
		height: 40px;
		background-color: #0092f1;
		border-radius: 3px;
		padding: 0px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button{
			padding: 12px 42px;
		}
		&>span{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content:space-around;
			justify-content: center;
		}
		
	}
	.deletbtn {
		width: 140px;
		height: 40px;
		background-color: #fff;
		border-radius: 3px;
		font-family: MicrosoftYaHei;
		font-size: 14px;
		font-weight: normal;
		font-stretch: normal;
		letter-spacing: 1px;
		color: #0092f1;
		padding: 0px;
		margin-left: 27px;
		img {
			// width: 18px;
			margin-right: 2px;
		}
		&.el-button{
			padding: 12px 42px;
		}
		&>span{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			// align-content:space-around;
			justify-content: center;
		}
	}
	.imgsize1 {
		width: 65px;
		// height: 65px;
	}
	.imgsize2{
		width: 72px;
	}
	.imgsize3{
		width: 68px;
	}
}
</style>
